import { isTaskId, type TaskId } from '@terros/common'

export type ShortSearch = {
  taskId?: TaskId
}

export const validateShortSearch = (search: Record<string, unknown>): ShortSearch => ({
  taskId: isTaskId(search.taskId) ? search.taskId : undefined,
})
